import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=d75ef844&scoped=true"
import script from "./CategoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=d75ef844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75ef844",
  null
  
)

export default component.exports